import React, { useEffect, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

const QrCodeScanner = ({
  onSuccess,
  onError,
  fps = 10,
  qrbox = { width: 250, height: 250 },
  verbose = false,
}) => {
  const qrCodeRef = useRef(null);
  const html5QrCodeScannerRef = useRef(null);

  useEffect(() => {
    if (qrCodeRef.current && !html5QrCodeScannerRef.current) {
      html5QrCodeScannerRef.current = new Html5QrcodeScanner(
        qrCodeRef.current.id,
        {
          fps, // Frames per second
          qrbox, // Scanning box dimensions
          aspectRatio: 1.0, // Adjust aspect ratio as needed
        },
        verbose // Enable verbose logging
      );

      html5QrCodeScannerRef.current.render(
        (decodedText, decodedResult) => {
          // console.log(">>decodedText ", decodedText);
          onSuccess(decodedText, decodedResult);
        },
        (errorMessage) => {
          onError(errorMessage);
        }
      );
    }

    return () => {
      if (html5QrCodeScannerRef.current) {
        html5QrCodeScannerRef.current.clear().catch((error) => {
          console.error('Failed to clear QR Scanner', error);
        });
        html5QrCodeScannerRef.current = null; // Reset the scanner reference
      }
    };
  }, [fps, qrbox, verbose, onSuccess, onError]);

  return <div id="qr-code-scanner" ref={qrCodeRef} style={{ width: '100%', height: '100%' }} />;
};

export default QrCodeScanner;
